import React, { useEffect, useContext, useState } from "react";
import DropDown from "../../components/_default/DropDown";
import MealplanPopupData from "../../components/_clients/LargePopup/mealplanPopupData";
import WorkoutPopupData from "../../components/_clients/LargePopup/WorkoutPopup/workoutPopupData";
import PhasePopupData from "../../components/_clients/LargePopup/PhasePopupData/";
import ClientsList from "../../components/_clients/ClientsList";
import ClientProfile from "../../components/_clients/ClientProfile";
import UserContext from "../../services/context/userContext";
import {
  getClients,
  getDailyMeasurementProgress,
  getCLientById,
  getAllCoaches,
  getAllClients,
} from "../../services/firebase/firestore/getData";
import Workout from "../../components/_clients/Workout";
import Chat from "../../components/_clients/Chat";
import Overview from "../../components/_clients/Overview";
import Calendar from "../../components/_clients/Calendar";
import CalendarItem from "../../components/_default/Calendar";
import Mealplan from "../../components/_clients/Form";
import Programsplan from "../../components/_clients/Programs";
import TodoList from "../../components/_clients/Calendar/TodoList";
import AddButton from "../../components/_default/AddButton";
import { useCookies } from "react-cookie";
import "./Subs.scss";
import Phase from "../../components/_phase";
import Loading from "../../components/_default/Loading";
import logo from "../../assets/images/logo.svg";
import Sub from "./sub";
import Subclients from "./subclients";
import SearchPage from "../../components/_default/SearchPage";

function UpgradeSubs({ ...props }) {
  const [cookies, setCookie] = useCookies(["clients_active_page"]);
  const [allCoaches, setAllCoaches] = useState([]);
  const [allClients, setAllClients] = useState([]);
  const [alphabetical, setAlphabetical] = useState(false);
  const [noCoach, setNoCoach] = useState(false);
  const [adminOnly, setAdminOnly] = useState(false);
  const [isRegisterDate, setIsRegisterDate] = useState(false);
  const [isRegisterDateClient, setIsRegisterDateClient] = useState(false);
  const [alphabeticalCoach, setAlphabeticalCoach] = useState(false);

  const [filtered, setFiltered] = useState([]);
  const [filteredCoach, setFilteredCoach] = useState([]);
  const filtersForCoach = ["Sort by  alphabetically", "Sort by account"];
  const [filterForCoach, setFilterForCoach] = useState(
    "Sort by  alphabetically"
  );
  const filterTypes = ["Ascending", "Descending"];
  const [filterTypeForCoach, setFilterTypeForCoach] = useState("Ascending");
  const [filterTypeForClient, setFilterTypeForClient] = useState("Ascending");
  const filtersForClient = ["Sort by name", "Sort by coach"];
  const [filterForCleint, setFilterForClient] = useState("Sort by name");
  let [searchCoach, setSearchCoach] = useState("");
  let [searchClient, setSearchClient] = useState("");
  let [descendingClient, setDescendingClient] = useState(false);
  let [descendingCoach, setDescendingCoach] = useState(false);
  let [clientSubsection, setClientSubsection] = useState(false);
  let [coachSubsection, setCoachSubsection] = useState(false);

  var a = new Date();
  var year = a.getFullYear();
  var month = a.getMonth() + 1;
  var day = a.getDate();

  if (month < 10) {
    month = "0" + month;
  }
  if (day < 10) {
    day = "0" + day;
  }
  var time = year + "-" + month + "-" + day;
  var currentTime = year + "-" + month + "-" + day;
  var date = day + "/" + month + "/" + year;
  let longMonth = a.toLocaleString("en-us", { month: "long" });
  const [fullTime, setFullTime] = useState(day + " " + longMonth + " " + year);
  let shortMonth = a.toLocaleString("en-us", { month: "short" });
  const [shortFullTime, setShortFullTime] = useState(
    day + " " + shortMonth + " " + year
  );
  const [Time, setTime] = useState(time);
  const user = useContext(UserContext);

  const DropDownOptions = ["Trial", "Closed", "Paid"];
  function sortClientDesc(a, b) {
    const name1 = a.first_name.toLowerCase() + " " + a.last_name.toLowerCase();
    const name2 = b.first_name.toLowerCase() + " " + b.last_name.toLowerCase();

    let comparison = 0;

    if (name1 < name2) {
      comparison = 1;
    }
    if (name1 > name2) {
      comparison = -1;
    }
    return comparison;
  }
  const handleOrdering = (e) => {
    console.log("order by", e);
    setDescendingCoach(!descendingCoach);
    setFilterTypeForCoach(
      filterTypeForCoach == "Ascending" ? "Descending" : "Ascending"
    );
  };
  const handleSortDropDownForCoach = (e) => {
    console.log("sorting in acsess", e);
    setFilterForCoach(e);
  };
  useEffect(() => {
    // debugger
    if (searchCoach || searchClient) {
      if (searchCoach) {
        getAllCoaches((callback) => {
          console.log("all coaches in searchCoach callback", callback);
          const results = callback.filter((coach) => {
            if (searchCoach === "") return callback;
            return (coach.first_name + " " + coach.last_name)
              .toLowerCase()
              .includes(searchCoach.toLowerCase());
          });
          setAllCoaches(results);
        });
      }

      if (searchClient) {
        // debugger
        console.log("search client use effe", searchClient);
        getAllClients((callback) => {
          // console.log("all client callback", callback);
          const results = callback.filter((client) => {
            if (searchClient === "") return callback;
            return (client.first_name + " " + client.last_name)
              .toLowerCase()
              .includes(searchClient.toLowerCase());
          });
          setAllClients(results);
        });
      }
    } else if (descendingClient || descendingCoach) {
      if (descendingCoach) {
        getAllCoaches((callback) => {
          console.log("all coaches callback", callback);
          // _filtered.sort((a, b) => a.first_name.localeCompare(b.first_name))
          // callback.sort((a, b) => a.first_name.localeCompare(b.first_name))
          callback.sort(sortClientDesc);
          setAllCoaches(callback);
        });
      }
      if (descendingClient) {
        getAllClients((callback) => {
          // callback.sort((a, b) => a.first_name.localeCompare(b.first_name))
          callback.sort(sortClientDesc);
          setAllClients(callback);
          console.log(
            "all client callback",
            callback.filter((coach) => coach.first_name == "Test")
          );
        });
      }
    } else if (!descendingClient || !descendingCoach) {
      getAllCoaches((callback) => {
        console.log(
          "all coaches callback",
          callback.filter((coach) => coach.first_name == "Test")
        );
        // _filtered.sort((a, b) => a.first_name.localeCompare(b.first_name))
        callback.sort((a, b) => a.first_name.localeCompare(b.first_name));
        // callback.sort(sortClientDesc)
        setAllCoaches(callback);
      });

      getAllClients((callback) => {
        callback.sort((a, b) => a.first_name.localeCompare(b.first_name));
        setAllClients(callback);
        console.log(
          "all client callback filter",
          callback.filter((coach) => coach.first_name == "Test client")
        );
      });
    }
    // return ()=>{setFilterForCoach(false)}
  }, [searchCoach, searchClient, descendingClient, descendingCoach]);

  useEffect(() => {
    setFiltered([]);
    let _filtered = [];
    if (noCoach === true) {
      allClients.forEach((client) => {
        if (!client.coach) {
          _filtered.push(client);
        }
      });
    }
    if (filterForCleint == "Sort by coach") {
      allClients.forEach((client) => {
        if (client.coach) {
          _filtered.push(client);
        }
      });
    } else if (filterForCleint == "Sort by coach" && descendingClient) {
      getAllClients((callback) => {
        // callback.sort((a, b) => a.first_name.localeCompare(b.first_name))
        callback.sort(sortClientDesc);
        setAllClients(callback);
        console.log("all client callback", callback);
      });
    }
    if (
      alphabetical === true ||
      filterForCleint === "Sort by name" ||
      !descendingClient
    ) {
      _filtered.sort((a, b) => a.first_name.localeCompare(b.first_name));
      allClients.sort((a, b) => a.first_name.localeCompare(b.first_name));
    } else {
      allClients.sort((a, b) => 0.5 - Math.random());
    }
    if (descendingClient) {
      _filtered = _filtered.sort(sortClientDesc);
      // setFilteredCoach(_filtered)
      setFiltered(_filtered);
    } else {
      setFiltered(_filtered);
      // setFilteredCoach(_filtered);
    }
  }, [noCoach, alphabetical, filterForCleint, descendingClient]);

  const handleOrderingForClient = (e) => {
    console.log("order by", e);
    setDescendingClient(!descendingClient);
    setFilterTypeForClient(
      filterTypeForClient == "Ascending" ? "Descending" : "Ascending"
    );
  };
  const handleSortDropDownForClient = (e) => {
    console.log("sort drop down client", e);
    setFilterForClient(e);
  };
  useEffect(() => {
    setFiltered([]);
    let _filtered = [];
    if (adminOnly === true) {
      allCoaches.forEach((client) => {
        if (!client.admin) {
          _filtered.push(client);
        }
      });
    }
    if (filterForCoach === "Sort by account") {
      allCoaches.forEach((client) => {
        if (client.status && !client.admin) {
          _filtered.push(client);
        }
      });
    } else if (filterForCoach === "Sort by account" && descendingCoach) {
      // debugger
      allCoaches.forEach((client) => {
        if (client.status && !client.admin) {
          _filtered.push(client);
        }
        _filtered.sort(sortClientDesc);
      });
    } else if (
      filterForCoach === "Sort by  alphabetically" &&
      descendingCoach
    ) {
      getAllCoaches((callback) => {
        console.log("all coaches callback", callback);
        // _filtered.sort((a, b) => a.first_name.localeCompare(b.first_name))
        // callback.sort((a, b) => a.first_name.localeCompare(b.first_name))
        callback.sort(sortClientDesc);
        setAllCoaches(callback);
      });
    }

    if (
      alphabeticalCoach === true ||
      filterForCoach === "Sort by  alphabetically" ||
      !descendingCoach
    ) {
      _filtered.sort((a, b) => a.first_name.localeCompare(b.first_name));
      allCoaches.sort((a, b) => a.first_name.localeCompare(b.first_name));
    } else {
      allCoaches.sort((a, b) => 0.5 - Math.random());
    }

    if (descendingCoach) {
      _filtered = _filtered.sort(sortClientDesc);
      setFilteredCoach(_filtered);
    } else {
      setFilteredCoach(_filtered);
    }
    if (isRegisterDate) {
      // debugger
      // for register date code will be here
      getAllCoaches((callback) => {
        console.log(
          "all coaches callback",
          callback.filter((coach) => coach.first_name == "Coach")
        );
        let filterRegisterDate = callback.filter(
          (coach) => coach?.registrationDate
        );
       
        let res = filterRegisterDate.sort(function (a, b) {
        
          return (
            b.registrationDate?.toDate().getFullYear()-
            a.registrationDate?.toDate().getFullYear() 
          );
          
        });
        console.log("sort register date earliest to latest",res);
        console.log("register date", filterRegisterDate);
        setAllCoaches(res);
      });
    } else {
      getAllCoaches((callback) => {
        console.log(
          "all coaches callback",
          callback.filter((coach) => coach.first_name == "Coach")
        );
        callback.sort((a, b) => a.first_name.localeCompare(b.first_name));
        setAllCoaches(callback);
      });
    }

    if (isRegisterDateClient) {
      getAllClients((callback) => {
        // callback.sort((a, b) => a.first_name.localeCompare(b.first_name))
        // callback.sort(sortClientDesc);
        console.log(
          "all client callback",
          callback.filter((coach) => coach.first_name == "CLient")
        );
        let filterClientRegisterDate = callback.filter(
          (coach) => coach?.registrationDate
        );
        console.log("filter client registration", filterClientRegisterDate);
        let res = filterClientRegisterDate.sort(function (a, b) {
        
          return (
            b.registrationDate?.toDate().getFullYear()-
            a.registrationDate?.toDate().getFullYear() 
          );
          
        });
        setAllClients(res);
      });
    } else {
      getAllClients((callback) => {
        // callback.sort((a, b) => a.first_name.localeCompare(b.first_name))
        // callback.sort(sortClientDesc);
        callback.sort((a, b) => a.first_name.localeCompare(b.first_name));
        setAllClients(callback);
      });
    }
  }, [
    adminOnly,
    alphabeticalCoach,
    filterForCoach,
    descendingCoach,
    isRegisterDate,
    isRegisterDateClient,
  ]);
  //   useEffect(()=>{
  //     if(coachSubsection){

  //         setClientSubsection(false)
  //     }
  //     if(clientSubsection){
  //         setCoachSubsection(false)
  //     }
  //   },[clientSubsection,coachSubsection])

  return (
    <div className="c-page-wrapper c-page-dashboard c-page-exercises">
      <div className="c-header">
        <div className="c-header-container">
          <div className="c-header-nav" style={{ justifyContent: "center" }}>
            <h1 className="c-header-title">Access control</h1>
          </div>
          <div className="c-header-add"></div>
          <div className="c-header-logo">
            <img src={logo} alt="Logo" />
          </div>
        </div>
      </div>
      {/* <br /> */}
      <div className="c-form-submenu" style={{ height: "40px" }}>
        <div className="flex-box">
          {/* <div className={"c-side-form-menu-header --active"}>
            <div className="c-side-form-menu-header-title">
              <h3>{"Controls"}</h3>
            </div>
          </div> */}
          <div style={{ display: "flex", alignItems: "self-end" }}>
            <h3
              onClick={() => {
                setCoachSubsection(true);
                setClientSubsection(false);
              }}
              style={
                coachSubsection
                  ? {
                      fontWeight: "600",
                      borderWidth: "thin",
                      borderBottom: "solid",
                      cursor: "pointer",
                      marginLeft: "5px",
                    }
                  : { cursor: "pointer", marginLeft: "5px" }
              }
            >
              Coaches
            </h3>
            <h3
              onClick={() => {
                setClientSubsection(true);
                setCoachSubsection(false);
              }}
              style={
                clientSubsection
                  ? {
                      marginLeft: "10px",
                      fontWeight: "600",
                      borderWidth: "thin",
                      borderBottom: "solid",
                      cursor: "pointer",
                    }
                  : { cursor: "pointer", marginLeft: "15px" }
              }
            >
              Clients
            </h3>
          </div>
        </div>
      </div>
      <br />
      <br />

      {(() => {
        if (coachSubsection) {
          return (
            <>
              <div
                className="c-exercise-finder"
                style={{ margin: "0 auto", width: "95%" }}
              >
                <SearchPage
                  placeholder="Search coach"
                  value={searchCoach}
                  onChange={(e) => setSearchCoach(e.target.value)}
                />
                <div className="c-dropdown-holder">
                  <DropDown
                    options={filtersForCoach}
                    value={filterForCoach}
                    onChange={handleSortDropDownForCoach}
                  />
                  <DropDown
                    options={filterTypes}
                    value={filterTypeForCoach}
                    onChange={handleOrdering}
                  />
                </div>
              </div>
              <div className="c-page-wrapper--exercises">
                <div className="filters">
                  <h2 style={{ fontWeight: "bold" }}>Coaches</h2>
                  <div >
                    <div className="filters">
                      <p>No admin</p>
                      <label class="switch" style={{ position: "relative" }}>
                        <input
                          type="checkbox"
                          name="automatich"
                          checked={adminOnly ? true : false}
                          onClick={() => setAdminOnly(!adminOnly)}
                        />
                        <span class="slider round"></span>
                      </label>
                    </div>
                    <div className="filters">
                      <p>Register date</p>
                      <label class="switch" style={{ position: "relative" }}>
                        <input
                          type="checkbox"
                          name="automatich"
                          checked={isRegisterDate ? true : false}
                          onClick={() => setIsRegisterDate(!isRegisterDate)}
                        />
                        <span class="slider round"></span>
                      </label>
                    </div>
                    {/* <p>Alphabetic</p>
                        <label class="switch" style={{ position: 'relative' }}>
                            <input type="checkbox" name="automatich" checked={alphabeticalCoach ? true : false} onClick={() => setAlphabeticalCoach(!alphabeticalCoach)} />
                            <span class="slider round"></span>
                        </label> */}
                  </div>
                </div>
                <div className="c-page-main--exercises">
                  <div className="c-exercise-list">
                    {filteredCoach.length > 0
                      ? filteredCoach &&
                        filteredCoach.map((coach, idx) => (
                          <Sub key={idx} coach={coach} />
                        ))
                      : allCoaches &&
                        allCoaches.map((coach, idx) => (
                          <Sub key={idx} coach={coach} />
                        ))}
                  </div>
                </div>
              </div>
            </>
          );
        } else if (clientSubsection) {
          return (
            <>
              <div
                className="c-exercise-finder"
                style={{ margin: "0 auto", width: "95%" }}
              >
                <SearchPage
                  placeholder="Search client"
                  value={searchClient}
                  onChange={(e) => setSearchClient(e.target.value)}
                />
                <div className="c-dropdown-holder">
                  <DropDown
                    options={filtersForClient}
                    value={filterForCleint}
                    onChange={handleSortDropDownForClient}
                  />
                  <DropDown
                    options={filterTypes}
                    value={filterTypeForClient}
                    onChange={handleOrderingForClient}
                  />
                </div>
              </div>
              <div className="c-page-wrapper--exercises">
                <div className="filters">
                  <h2 style={{ fontWeight: "bold" }}>Clients</h2>
                  <div >
                    <div className="filters">
                      <p>No coach</p>
                      <label class="switch" style={{ position: "relative" }}>
                        <input
                          type="checkbox"
                          name="automatich"
                          checked={noCoach ? true : false}
                          onClick={() => setNoCoach(!noCoach)}
                        />
                        <span class="slider round"></span>
                      </label>
                    </div>
                    <div className="filters">
                      <p>Register date</p>
                      <label class="switch" style={{ position: "relative" }}>
                        <input
                          type="checkbox"
                          name="automatich"
                          checked={isRegisterDateClient ? true : false}
                          onClick={() => setIsRegisterDateClient(!isRegisterDateClient)}
                        />
                        <span class="slider round"></span>
                      </label>
                    </div>
                    {/* <p>Alphabetic</p>
                        <label class="switch" style={{ position: 'relative' }}>
                            <input type="checkbox" name="automatich" checked={alphabetical ? true : false} onClick={() => setAlphabetical(!alphabetical)} />
                            <span class="slider round"></span>
                        </label> */}
                  </div>
                </div>
                <div className="c-page-main--exercises"></div>
                <div className="c-exercise-list">
                  {filtered.length > 0
                    ? filtered &&
                      filtered.map((client, idx) => (
                        <Subclients key={idx} client={client} />
                      ))
                    : allClients &&
                      allClients.map((client, idx) => (
                        <Subclients key={idx} client={client} />
                      ))}
                </div>
              </div>
            </>
          );
        } else {
          return (
            <>
              <div
                className="c-exercise-finder"
                style={{ margin: "0 auto", width: "95%" }}
              >
                <SearchPage
                  placeholder="Search coach"
                  value={searchCoach}
                  onChange={(e) => setSearchCoach(e.target.value)}
                />
                <div className="c-dropdown-holder">
                  <DropDown
                    options={filtersForCoach}
                    value={filterForCoach}
                    onChange={handleSortDropDownForCoach}
                  />
                  <DropDown
                    options={filterTypes}
                    value={filterTypeForCoach}
                    onChange={handleOrdering}
                  />
                </div>
              </div>
              <div className="c-page-wrapper--exercises">
                <div className="filters">
                  <h2 style={{ fontWeight: "bold" }}>Coaches</h2>
                  <div className="">
                    <div className="filters">
                      <p>No admin</p>
                      <label class="switch" style={{ position: "relative" }}>
                        <input
                          type="checkbox"
                          name="automatich"
                          checked={adminOnly ? true : false}
                          onClick={() => setAdminOnly(!adminOnly)}
                        />
                        <span class="slider round"></span>
                      </label>
                    </div>
                    <div className="filters">
                      <p>Register date</p>
                      <label class="switch" style={{ position: "relative" }}>
                        <input
                          type="checkbox"
                          name="automatich"
                          checked={isRegisterDate ? true : false}
                          onClick={() => setIsRegisterDate(!isRegisterDate)}
                        />
                        <span class="slider round"></span>
                      </label>
                    </div>
                    {/* <p>Alphabetic</p>
                        <label class="switch" style={{ position: 'relative' }}>
                            <input type="checkbox" name="automatich" checked={alphabeticalCoach ? true : false} onClick={() => setAlphabeticalCoach(!alphabeticalCoach)} />
                            <span class="slider round"></span>
                        </label> */}
                  </div>
                </div>
                <div className="c-page-main--exercises">
                  <div className="c-exercise-list">
                    {filteredCoach.length > 0
                      ? filteredCoach &&
                        filteredCoach.map((coach, idx) => (
                          <Sub key={idx} coach={coach} />
                        ))
                      : allCoaches &&
                        allCoaches.map((coach, idx) => (
                          <Sub key={idx} coach={coach} />
                        ))}
                  </div>
                </div>
              </div>
              <br />
              <br />
              <br />
              <div
                className="c-exercise-finder"
                style={{ margin: "0 auto", width: "95%" }}
              >
                <SearchPage
                  placeholder="Search client"
                  value={searchClient}
                  onChange={(e) => setSearchClient(e.target.value)}
                />
                <div className="c-dropdown-holder">
                  <DropDown
                    options={filtersForClient}
                    value={filterForCleint}
                    onChange={handleSortDropDownForClient}
                  />
                  <DropDown
                    options={filterTypes}
                    value={filterTypeForClient}
                    onChange={handleOrderingForClient}
                  />
                </div>
              </div>
              <div className="c-page-wrapper--exercises">
                <div className="filters">
                  <h2 style={{ fontWeight: "bold" }}>Clients</h2>
                  <div >
                    <div className="filters">
                      <p>No coach</p>
                      <label class="switch" style={{ position: "relative" }}>
                        <input
                          type="checkbox"
                          name="automatich"
                          checked={noCoach ? true : false}
                          onClick={() => setNoCoach(!noCoach)}
                        />
                        <span class="slider round"></span>
                      </label>
                    </div>
                    {/* <p>Alphabetic</p>
                        <label class="switch" style={{ position: 'relative' }}>
                            <input type="checkbox" name="automatich" checked={alphabetical ? true : false} onClick={() => setAlphabetical(!alphabetical)} />
                            <span class="slider round"></span>
                        </label> */}

                    <div className="filters">
                      <p>Register date</p>
                      <label class="switch" style={{ position: "relative" }}>
                        <input
                          type="checkbox"
                          name="automatich"
                          checked={isRegisterDateClient ? true : false}
                          onClick={() => setIsRegisterDateClient(!isRegisterDateClient)}
                        />
                        <span class="slider round"></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="c-page-main--exercises"></div>
                <div className="c-exercise-list">
                  {filtered.length > 0
                    ? filtered &&
                      filtered.map((client, idx) => (
                        <Subclients key={idx} client={client} />
                      ))
                    : allClients &&
                      allClients.map((client, idx) => (
                        <Subclients key={idx} client={client} />
                      ))}
                </div>
              </div>
              <br />
              <br />
              <br />
            </>
          );
        }
      })()}
    </div>
  );
}

export default UpgradeSubs;
